import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { NotificationsProvider } from "@/context/NotificationsContext";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import AuthCallback from "@/pages/AuthCallback";
import Layout from "@/components/Layout";
import Play from "@/pages/Play";
import Courts from "@/pages/Courts";
import Passport from "@/pages/Passport";
import Club from "@/pages/Club";
import Profile from "@/pages/Profile";
import Home from "@/pages/Home";
import Social from "@/pages/Social";
import AdminCourts from "@/pages/AdminCourts";
import PostShare from "@/pages/PostShare";
import Messages from "@/pages/Messages";
import { Loader2 } from "lucide-react";

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center"><Loader2 className="animate-spin pv-text-dark" size={28}/></div>;
  if (!user) return <Navigate to="/login" replace/>;
  return children;
}

function AppShell() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<Login/>} />
      <Route path="/register" element={<Register/>} />
      <Route path="/p/:id" element={<PostShare/>} />
      <Route element={<ProtectedRoute><Layout/></ProtectedRoute>}>
        <Route path="/" element={<Navigate to="/home" replace/>}/>
        <Route path="/home" element={<Home/>} />
        <Route path="/play" element={<Play/>} />
        <Route path="/train" element={<Navigate to="/home" replace/>} />
        <Route path="/social" element={<Social/>} />
        <Route path="/courts" element={<Courts/>} />
        <Route path="/passport" element={<Passport/>} />
        <Route path="/club" element={<Club/>} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/messages" element={<Messages/>} />
        <Route path="/admin/courts" element={<AdminCourts/>} />
      </Route>
      <Route path="*" element={<Navigate to="/home" replace/>} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <NotificationsProvider>
          <AppShell />
        </NotificationsProvider>
        <Toaster position="top-center" richColors closeButton toastOptions={{ style: { fontFamily: "Inter, sans-serif" } }}/>
      </AuthProvider>
    </BrowserRouter>
  );
}
